export const DefaultRoutes = [
  {
    path: '/willkommen/:promotion',
    name: 'promotion-redirect',
    component: () =>
      import(
        /* webpackChunkName: "home" */ /* webpackPreload: true */ '../views/Search.vue'
      ),
    meta: {
      breadcrumb: 'Home',
    },
  },
]
